<div class="approval-redirect">
  <span class="approval-redirect__icon" mwc-icon mwcIconfont="arrow-up-right" aria-hidden="true"></span>

  <h1 class="approval-redirect__title">Hang Tight!</h1>
  <p class="approval-redirect__description">
    Redirecting you to Approval Management, where you can review and manage content.
  </p>
</div>
